import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useState } from 'react';
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import { Box, RadioGroup } from '@mui/material';
import { FilterButton } from 'console/tabs/events/components/filter-button';
import { setPeriod } from 'console/period/actions';
import { usePartial } from 'shared/hooks/utils';
import { any2unixtime, todayEnd, todayStart } from 'webui/utils/time';
import { selectNullableSelectedDeviceId } from 'entities/device/lib';
import { EventsBatches } from './components/batches';
import { PeriodWidget } from 'console/period';
import { LastEvents } from 'console/tabs/events/last-events';
import { isSmallUI } from 'shared/app/lib/choose-ui-type';
import { CustomRadioButton } from 'console/shared/components/fields';
export const EventsTab = memo(function EventsTab(props) {
    const { active } = props;
    const [activeControl, setActiveControl] = useState('PeriodWidget');
    const device_id = useAppSelector(selectNullableSelectedDeviceId);
    const period = useAppSelector((state) => state.period);
    const { mintime, maxtime } = period;
    const onSetPeriod = useAction(setPeriod);
    const onChangePeriod = useCallback((from, to) => {
        setActiveControl('PeriodWidget');
        onSetPeriod(from, to, true);
    }, []);
    const onSetActiveControl = useCallback((_, value) => setActiveControl(value), []);
    const onSetLastEvent = usePartial(setActiveControl, 'LastEvents');
    if (device_id == null) {
        return null;
    }
    return (_jsxs(Box, { display: "flex", height: "100%", flexDirection: "column", px: 2, pb: 2, children: [_jsxs(Box, { px: 0, py: 1, display: "flex", alignItems: isSmallUI() ? 'flex-end' : 'center', justifyContent: "space-between", children: [_jsxs(RadioGroup, { defaultValue: "PeriodWidget", sx: { mr: '-100px' }, value: activeControl, onChange: onSetActiveControl, children: [_jsx(CustomRadioButton, { value: "PeriodWidget", children: _jsx(PeriodWidget, { mintime: mintime ?? any2unixtime(todayStart()), maxtime: maxtime ?? any2unixtime(todayEnd()), onDatesSelected: onChangePeriod, isActive: activeControl === 'PeriodWidget' }) }), _jsx(CustomRadioButton, { value: "LastEvents", children: _jsx(LastEvents, { device_id: device_id, isActive: activeControl === 'LastEvents', onClick: onSetLastEvent }) })] }), _jsx(FilterButton, {})] }), _jsx(EventsBatches, { active: active, device_id: device_id })] }));
});
